import $ from 'jquery'
import Slider from 'react-slick'
import React, { useState, useRef, useEffect } from 'react'

const settingsSlick = {
  dots: false,
  infinite: true,
  items: 1,
  speed: 500,
  fade: false,
  slidesToShow: 1,
  slidesToScroll: 1,
}

//Helpers
import { getCover, getPreviewSlider, getQuality } from '@helpers/helper.rendering'
import { getPrices } from '@helpers/helper.properties'
import { addMarker } from '@helpers/helper.map'
import Loader from '@components/loader/1'
import {
  DevelopmentMediacore,
  FiltersProperties,
  Photo,
  Property,
  RealEstateDataPageComponentData,
  StatePropertiesSlice,
} from 'types'
import { useDispatch, useSelector } from 'react-redux'
import { changeSelectedAction, updateFocusProperty } from '@slices/propertiesSlice'
interface Props {
  property: DevelopmentMediacore
  settings: any
  dispatch: any
  skeleton: boolean
  filters: FiltersProperties
  setZoom: any
  map: any
  handlerClick: any
  isLeaflet: boolean
  opacity: boolean
  inMap: boolean
  grid_map: boolean
  basic: boolean
  customOperation?: string
}

const Card_Property_5 = ({
  property,
  skeleton,
  opacity,
  inMap,
  grid_map,
  basic,
  global_data,
  customOperation,
}: Props & RealEstateDataPageComponentData) => {
  const { divisionPath } = global_data

  const backgroundSecondary = global_data.content.cardsProperties.data.backgroundSecondary
  const backgroundColor = global_data.content.cardsProperties.data?.backgroundColor
  const backgroundHexa = global_data.content.cardsProperties.data?.backgroundHexa
  const opacityGradient = global_data.content.cardsProperties.data?.opacityGradient

  const lowPrice = true

  const sliderRef = useRef<any>()

  const { selected, filters } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!

  const addHoverMap = (property: Property) => {
    $('#marker-' + property?.id).addClass(' hover-marker')
    $('#marker-' + property?.development?.id).addClass(' hover-marker')
  }

  const removeHoverMap = () => {
    $('#marker-' + property?.id).removeClass(' hover-marker')
  }

  const toggleModal = (boolean: boolean) => {
    document.body.classList.remove('modal-open')
    $('#exampleModal').hide()
    $('.modal-backdrop').hide()
    document.body.style.overflow = 'auto'
  }

  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => {
    setIsMounted(true)
  }, [])

  const dispatch = useDispatch()

  const truncateText = (text: string, maxLength: number) =>
    text.length > maxLength ? text.slice(0, maxLength) + '...' : text

  return (
    isMounted && (
      <div
        onMouseEnter={() => addHoverMap(property)}
        onMouseLeave={() => removeHoverMap()}
        id={'card-grid-' + (grid_map && property?.id)}
        onClick={() => {}}
        className={
          'card prop b dev-card-results prop-card  ' +
          (skeleton && ' skeleton ') +
          (inMap ? ' map-card ' : '') +
          (opacity ? ' opacity-card ' : '') +
          (grid_map ? ' grid-card me-3 ' : '') +
          (backgroundSecondary ? ' theme-secondary ' : '')
        }
      >
        <div
          className={'card-image ' + (grid_map && 'grid_map_image')}
          style={{ border: 'none' }}
        >
          {skeleton && <Loader />}
          {basic ? (
            <a
              target="_blank"
              href={`${divisionPath ?? ''}/emprendimiento/${property?.name}/${property?.id}`}
            >
              <img
                src={skeleton ? '' : getQuality(getCover(property?.photos))}
                className="notScale"
                alt={'image propiedad'}
              />
            </a>
          ) : (
            property?.photos && (
              <>
                <Slider
                  ref={sliderRef}
                  {...settingsSlick}
                  className="overflow-hidden card-carousel"
                >
                  {getPreviewSlider(property?.photos).map((photo: Photo, index: number) =>
                    grid_map ? (
                      <a
                        target="_blank"
                        href={`${
                          divisionPath ?? ''
                        }/emprendimiento/${property?.name}/${property?.id}`}
                      >
                        <img
                          key={index}
                          src={index === 0 ? getQuality(photo) : getQuality(photo)}
                          className="notScale"
                          alt={'Imagen de tokkoBroker'}
                        />
                      </a>
                    ) : (
                      <a
                        key={index}
                        target={'_blank'}
                        href={`${
                          divisionPath ?? ''
                        }/emprendimiento/${property?.name}/${property?.id}`}
                      >
                        {
                          <img
                            src={index === 0 ? getQuality(photo) : getQuality(photo)}
                            className="notScale"
                            alt={'Imagen de tokkoBroker'}
                          />
                        }
                      </a>
                    ),
                  )}
                </Slider>
                {getPreviewSlider(property?.photos)?.length > 1 && (
                  <div className="arrows-owl minimal left">
                    <div
                      className="arrow"
                      onClick={() => sliderRef.current.slickPrev()}
                    >
                      {' '}
                      <i></i> <i></i>
                    </div>
                  </div>
                )}
                {getPreviewSlider(property?.photos)?.length > 1 && (
                  <div className="arrows-owl minimal right">
                    <div
                      className="arrow reverse"
                      onClick={() => sliderRef.current.slickNext()}
                    >
                      {' '}
                      <i></i> <i></i>{' '}
                    </div>
                  </div>
                )}
              </>
            )
          )}
          <div className="badges">
            {property ? (
              <div
                className="badge"
                style={{ backgroundColor: '#FFF', color: '#1d1d1d' }}
              >
                {property?.location?.neighborhood}
              </div>
            ) : (
              <div className={'badge'}>XXXXX</div>
            )}
            {property ? (
              <div
                className="badge"
                style={{ backgroundColor: '#FFF', color: '#1d1d1d' }}
              >
                {property?.construction_status}
              </div>
            ) : (
              <div className={'badge'}>XXXXX</div>
            )}
          </div>
          <div
            onClick={() => toggleModal(false)}
            className="close-card"
          >
            <i></i>
            <i></i>
          </div>
        </div>
        <div
          onClick={() => {
            addMarker(property.id)!

            selected !== property.id
              ? dispatch(updateFocusProperty(property.id))
              : dispatch(updateFocusProperty(null))
            selected !== property.id
              ? dispatch(changeSelectedAction(property.id))
              : dispatch(changeSelectedAction(null))
          }}
          className={'card-body ' + (grid_map && 'grid-card-body')}
          style={{ border: '1px solid #d6d6d6', borderLeft: 'none' }}
        >
          <div className={'content-extra row align-items-center '}>
            <div className={grid_map ? 'col-12' : 'col-12'}>
              <div className="row">
                {/* Title */}
                <h4
                  className={`card-title my-3 col-12 text-uppercase
                    ${grid_map ? ' my-lg-2 mt-lg-3 ' : ''}`}
                  style={{ color: '#1d1d1d' }}
                >
                  {!grid_map ? (
                    <div style={{ fontSize: 'inherit', fontFamily: 'inherit' }}>
                      {property?.name}
                    </div>
                  ) : (
                    <div style={{ fontSize: 'inherit', fontFamily: 'inherit' }}>
                      {property?.name}
                    </div>
                  )}
                </h4>
                {/* Details */}
                <div className="col-12">
                  <div
                    className={`details d-flex align-items-center justify-content-start mb-3 ${
                      grid_map ? 'mb-lg-1' : ''
                    } `}
                    style={{ borderBottom: 'none' }}
                  >
                    {property?.description ? (
                      <div
                        className="details-item d-flex justify-content-center align-items-center py-1 me-2 pe-3"
                        style={{ color: '#000' }}
                      >
                        {truncateText(property.description, 150)}
                      </div>
                    ) : null}
                  </div>
                </div>
                {/* Price */}
                <div
                  className={
                    'align-items-center-end justify-content-between d-flex mt-2 ' +
                    (grid_map ? 'mt-lg-3' : 'mt-lg-0')
                  }
                >
                  {skeleton ? (
                    <div className="d-block mt-2 mt-lg-2">
                      <h3 className={'prop-price mb-1 '}>
                        <div className="d-flex align-items-center">
                          <div className={'previous align-items-center me-3 d-flex '}>
                            {' '}
                            <div className="inline-block text-through">XX XXX</div>{' '}
                          </div>
                        </div>
                      </h3>
                      <h3 className={'prop-price me-3 mb-0 '}>
                        <div className="d-flex align-items-center">
                          <div>XXXX XXXXXXX</div>
                          {<small className="ms-2"> XXXXX</small>}
                        </div>
                      </h3>
                    </div>
                  ) : (
                    getPrices(property).map((price, index) => (
                      <div
                        key={index}
                        className={
                          customOperation === price.type.toLowerCase() ||
                          price.type.toLowerCase().replaceAll(' ', '-') ===
                            filters?.operation?.toLowerCase().replaceAll(' ', '-') ||
                          (price.type.includes('temporario') && filters.operation === 'temporario')
                            ? 'd-block '
                            : 'd-none '
                        }
                      >
                        <h5
                          className={'prop-price mb-1 ' + price.type + (lowPrice ? '' : ' d-none')}
                        >
                          <div className="d-flex align-items-center">
                            <div
                              className={
                                'previous align-items-center me-3 ' +
                                (price.is_less_than_previous_price ? 'd-flex' : 'd-none')
                              }
                            >
                              {' '}
                              <div className="inline-block text-through">
                                {price.currency}{' '}
                                {price?.previous_price! > 0
                                  ? Intl.NumberFormat('de-DE').format(price?.previous_price!)
                                  : price.previous_price}{' '}
                              </div>{' '}
                              <i className="icon-arrow_down"></i>{' '}
                            </div>
                          </div>
                        </h5>
                        <h5 className={'prop-price me-3 mb-0 ' + price.type}>
                          <div className="d-flex align-items-center">
                            <div style={{ fontSize: 'inherit' }}>
                              {price.currency}{' '}
                              {typeof price.price === 'number'
                                ? Intl.NumberFormat('de-DE').format(price.price)
                                : price.price}
                            </div>
                            {price.period ? (
                              <small className="ms-2"> ( {price.period}) </small>
                            ) : (
                              ''
                            )}
                          </div>
                        </h5>
                      </div>
                    ))
                  )}
                  {!skeleton && (
                    <a
                      className={
                        'read-more btn btn-secondary ' + (opacityGradient ? 'is-fill' : '')
                      }
                      target={'_blank'}
                      style={{
                        background: opacityGradient ? backgroundColor : '',
                        color: opacityGradient ? backgroundHexa : '',
                      }}
                      href={`${
                        divisionPath ?? ''
                      }/emprendimiento/${property?.name}/${property?.id}`}
                    >
                      Ver más
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
}

export default Card_Property_5
